import { DEFAULT_MAX_WIDTH_XL } from '@dbh/styled-helpers';

const THEME_KEY_SECTION="section";const getSectionTheme=()=>({[THEME_KEY_SECTION]:{alignSelf:"center",noBorderBottom:"false",noLeftRightMargins:"false",desktop:{alignSelf:"center",width:"90%",maxWidth:DEFAULT_MAX_WIDTH_XL}}});// We don't put these in the theme, because they are not intended to be
// overridden, not to add complexity that has proven to be difficult to
// handle.
const TOP_SECTION_PADDING="sp7";const BOTTOM_SECTION_PADDING="sp7";const SIDES_SECTION_MARGIN="sp6";

export { BOTTOM_SECTION_PADDING, SIDES_SECTION_MARGIN, THEME_KEY_SECTION, TOP_SECTION_PADDING, getSectionTheme as default };
